import { useMemo } from "react";
import { flattenFields } from "../utils";
import { Field } from "../dto";

// 扁平化字段
const useFlattenFields = (fields: Field[]) => {
  return useMemo(() => {
    const flds = flattenFields(fields);
    return [flds, flds.map((i) => i.code), flds.map((i) => i.name)] as const;
  }, [JSON.stringify(fields)]);
};

export default useFlattenFields;
